<template>
<BaseModal :id="'copy-inspection-sent-modal'" :title="`Copy Inspections Sent ${show_associates ? `- ${inspection_name}` : ''}`" :size="'lg'" :message="!show_associates ? message : message_2" @close="close($event)">
    <template v-slot:breadcrumb>
        <Breadcrumb :breadcrumb="breadcrumb" />
    </template>
    <template v-slot:content>
        <div class="input-field my-3" v-if="!show_associates">
            <i class="material-icons prefix iconInput">search</i>
            <input id="icon_prefix" type="text" class="validate inputSearch" placeholder="Search" v-model="search">
        </div>
            <DinamicTable   
                :headers="table_headers"
                :items="data"
                :checkable="true"
                :search="search"
                v-if="!show_associates"
                @emitLinkAction="emitLinkAction($event)"
                ref="dinamic_table"
            />
            <form @submit.prevent="sendInspection()" v-else>
                <FormDynamic :form_format="form_format" :form_data="form_data" :array_options="array_options" :for_update="false"/>
                <CentralLiteButtons :save_text="'Send'" :cancel_text="'Go back'" :not_close_modal="true" @Cancelation="close($event)"/>
            </form>
    </template>
</BaseModal>
</template>

  
  
<script>
import Breadcrumb from "@/components/BreadcrumbComponent/Breadcrumb";
import CentralLiteButtons from '@/components/CentralLiteButtons'
import DinamicTable         from    '@/components/DinamicTable'
import BaseModal from "@/components/BaseModal";
import FormDynamic from '@/components/FormDynamic'
import FormResources from "./InspectionComplete/form_resources";

export default {
    name: "CopyInspectionSentModal",

    props: ["breadcrumb", "data", "rest_api"],

    components: {
        BaseModal,
        Breadcrumb,
        CentralLiteButtons,
        DinamicTable,
        FormDynamic
    },

    data() {
        return {
            form_format: FormResources.form_format_for_mail_inspection,
            form_data: FormResources.form_data_for_mail_inspection,
            table_headers: [
                {
                    text: "Inspection",
                    value: "title"
                },
                {
                    text: "Date",
                    value: "format_date"
                },
                {
                    text: "Type",
                    value: "inspection_type_name"
                },
                {
                    text: "Actions",
                    value: "Email inspection",
                    type: "link_action"
                }
            ],
            message: `The completed inspections have been sent to their respective associates. To resend a specific inspection, please choose the desired inspection and click the 'Send Inspection Copy' button.`,
            message_2: `Since this inspection has been completed, and one or more associates have contributed, please select the associate you want to send the inspection results to. Each associate will only be able to view the inspection items they worked on.`,
            select_all: false,
            search: '',
            show_associates: false,
            array_options: {
                associate_id: []
            },
            inspection_name: '',
            inspection_id: undefined
        };
    },

    methods: {
        async emitLinkAction(event)
        {
            this.show_associates = true

            const inspection = this.$refs.dinamic_table.display_items[event]
            this.inspection_name    = inspection.title
            this.inspection_id      = inspection.id
            const response = await this.get(`${this.rest_api}/get/inspection_associates/${this.inspection_id}`)

            if(response.status)
            {
                this.array_options = {...this.array_options, associate_id: response.data.associates}
            }
            else
            {
                this.error_handling(response)
            }
        },

        close() {
            if(this.show_associates)
            {
                this.show_associates = false
                return
            }
        },

        
        selectAll() {
            this.data.map(item => item.checked = this.select_all)
        },

        async sendInspection() 
        {
            let json_request = {
                associate_id: this.form_data.associate_id,
                inspection_id: this.inspection_id,
            }

            const response = await this.postingByPost(`${this.rest_api}/post/send_copy_inspections_individually`, json_request, 'copy-inspection-sent-modal', false)

            if (response.status) 
            {
                this.form_data.associate_id = []
                this.show_associates = false
                this.notyfMesg('Success')
            }
            else
            {
                this.error_handling(response)
            }
        },
    },

    computed: {},

    mounted() {},
};
</script>
